//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailTraProUdalost.ts						</Name>
//    <Description> Dialog detailu ginsevn - Ud�lost										</Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-09-14                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(ginsevn) GID:(Web.Det.Ts) V1:(evn_por_cislo,log_por_cislo,iud_por_od,iud_por_do,dat_evn,ktg_evn,typ_evn,res_evn,proces_id,proces_txt,typ_subj,sxs_subj,tab_name,proces_src,klas_evn,ixs_aus,priz_zobr,zmenu_prov) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

    /** inteface - Response slu�eb pro Detail */
    export interface IDetailTraProUdalostResponse {
        /** data v�stupu */
        data: Gordic.AdmIsl.Interface.GTraProUdalostReadDto,

        result: {
            /** data v�stupu */
            data: Gordic.AdmIsl.Interface.GTraProUdalostReadDto,
            /** chyby */
            errors: {
                /** zpr�va chyby */
                message: string
            }[],
            /** typ v�stupu operace */
            kind: Adm.Utils.GOperationResultKind
        }
    }

	//#endregion

	/** Dialog detailu  */
	@gcontent
    export class DetailTraProUdalost extends GContentBase<DetailBase> {

		//#region attributes

        private gridRemoteControl: Gordic.Components.GridRC<any>;
		private gridCssClass: string;
		private gtableParametry: JQuery<HTMLElement>;

            /** PK - evn_por_cislo */
            private evn_por_cislo: number | null;
        
        /** data detailu */
        private data: Gordic.AdmIsl.Interface.GTraProUdalostReadDto;
		/** p��znak p��m�ho p��stupu na detail */
		private detailCommand: boolean
		/** Tab pro xxxx */
		//private strediskaTab: GStrediskaTab;

		//#endregion

		//#endregion


        /** onContentReady */
        public onContentReady() {
            this.init();
        }
		//#region ready & init

        public closing() {
            return DetailBase.CloseAction(this);
        }

        /** refreshDetail content */
        private refreshDetail(): void {
			this.load();
		}

        /** Na�ten� dat ze serveru na n�sledn� nastaven� na detail okn� */
        private loadData() {
            this.editMode = false;      // na��t�n� jde v�dy do ReadOnly m�du

            var fragments: string[] = [Utils.GAdmIslConst.detail];

            if (this.newRecord) {
                fragments.push(Utils.GAdmIslConst.defaultValuesForNewRecord);
            }

           this.isl.TraProUdalost.read({
                data: { evn_por_cislo: this.evn_por_cislo },
                fragments: fragments
            }).get().done((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.data = output.data;
                    this.sxsDetail = this.data.evn_por_cislo?.toString();
                    // p�evzet� dat do PK
                    this.evn_por_cislo = this.data.evn_por_cislo || null;
                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
					this.createForm();
					this.createGTableParametry();
                    this.element.findFields().gfield("model", "apply", this.data);
                    if (this.newRecord) 
                        this.SetEditMode(true)
                    this.SetMenuButtons(this.editMode);
					this.createSidebar();
					this.isl.TraProUdalostParametr.list({ filters: { evn_por_cislo: this.evn_por_cislo } }).getData().done((data) => {
						this.gtableParametry.gtable("setData", data);
					})
                } else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
						var error = errors[index];
						this.ShowErrorNot({ text: error.message, title: "jres:29802537" })
                    }
                }
            }).fail((err) => {
				console.error("Chyba na�ten�! " + err);
				if (err.responseJSON.exception.containsNonFatal != true)
					this.ShowErrorNot({ text: "jres:32131045!", title: "jres:29802537" })
            });   
        } // loadData

		//#endregion

		/** init content */
        private init() {
			DetailBase.DetailBaseInit(this);
			//this.strediskaTab = new GStrediskaTab();

            this.formElement = null;
			// lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
				this.actions.addRange(GinListControlsObject.actions);
				this.createStatusBar(GinListControlsObject.statusBar);
				$.extend(this, GinListControlsObject.contentExtensions);
			}

			this.setTitle();
			this.createMenuBar();
			this.loadData();            // to soucasne vytvori form podle nactenych dat; 
			this.createCommandBar();

            // lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				// vytvo�it �ipky na proch�zen� detailu
                (this as any).listControls_setup({
                    //gridRemoteControl: this.gridRemoteControl,
					//funkce, kter� ��dek z gridu p�etransformuje v dto pro zavol�n� this.load(dto); M��e vracet promise.
					rowToDto: function (gridState) {
						return {
                            evn_por_cislo: gridState.currentRow.data.evn_por_cislo,
						};
					},
					//template pro tooltip na �ipce n�sleduj�c�
                    nextItemTemplate: "jres:33000155",
					//template pro tooltip na �ipce p�edchoz�
                    prevItemTemplate: "jres:33000156"
				});
				(this as any).listControls_updateCaptions();
            }
		}

		/** vytvo�it statusbar */
		private createStatusBar(GinListControlsObject?: any) {
			const bar: MenuParams[] = [];
			if (GinListControlsObject !== undefined) {
				bar.push.apply(bar, GinListControlsObject);
			}
			this.statusBar(bar);
		}

		//#endregion

		//#region title

		/** nastavit titulek dialogu */
		private setTitle() {

            var title = "";

            if (this.newRecord === false) {
                title = "jres:32131033"  	//RC 32131033 : Detail
            }
            else {
                title = "jres:32000121" //RC 32000121 : Nov� z�znam
            }

			this.title = title;

		}


		//#endregion

		//#region form

		/** vytvo�it formul�� a na�ten� dat ze serveru */
        private createForm() {
          var nemenne = "jres:32131150"; //RC 32131150 : Nem�nn�
          this.MakeForm("FormTraProUdalostService");
            this.MakeSection("jres:29802537"); //RC 29802537 :  Ud�lost
			this.MakeField("evn_por_cislo");
			this.MakeField("dat_evn");
			this.MakeSelectField("ktg_evn", Gordic.Prefabs.Select.gincevn(), { model: "model.ktg_evn=value.ktg_evn" })
			this.MakeSection("jres:33000136"); //RC 33000136 : Realizoval
			this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), { model: "model.ixs_fun=value.ixs_fun" });
			this.MakeSelectField("faze", Gordic.Prefabs.Select.gincfaz(), { model: "model.faze=value.faze" });
			this.MakeField("revize");
			this.MakeSelectField("ip_adr", Gordic.Prefabs.Select.ginssta(), { model: "model.ip_adr=value.ip_adr" });
			this.MakeField("login_win");
			this.MakeField("dat_login");
			this.MakeField("dat_logout");
			this.MakeField("login_uziv");
			this.MakeField("log_por_cislo");
          var form = this.FinishMakeForm();

		}

		private createGTableParametry() {
			var gtab = $("<div>").appendTo(this.element).gtab({
				title: "jres:33000133",
				opened: true,
			})

			this.gtableParametry = $("<div>").appendTo(gtab).gtable({
				columns: new Gordic.Data.GridFormat()
					.addTextColumn({
						name: "var_name_txt",
						caption: "jres:33000135", //RC 33000135 : Parametr ud�losti
					})
					.addTextColumn({
						name: "var_value_txt",
						caption: "jres:29932124"
					})
			})
        }

		//#endregion

		//#region menubar

		private nextAndPreviousAction(next: boolean) {
		    var obj: any;
		    if (next == true)
		        obj = this.gridRemoteControl.current().nextRow.data;
		    else
		        obj = this.gridRemoteControl.current().prevRow.data;
		    this.gridRemoteControl.move(next);
		    var gridElement = this.gridRemoteControl as any;
		    Dialogs.DetailTraProUdalostDlg($.content(gridElement.gridInstance.element), { evn_por_cislo: obj.evn_por_cislo, grid:gridElement.gridInstance.element, newRecord: false })
		this.close();
		}

		/** vytvo�it menubar */
		private createMenuBar() {

			const menuBar: MenuParams[] = [];

			this.actions.addRange({ 
			actNext: {
			        name: "actNext",
			        caption: "jres:33000001",  //RC 33000001 : Dal���
			        captionVisible: "never",
			        icon: "gi-arrow-down",
			        run: (ev, ctx) => {
			            this.nextAndPreviousAction(true);
			        }
			    },
			    actPrevious: {
			        name: "actPrevious",
			        caption: "jres:33000002", //RC 33000002 : P�edchoz�
			        captionVisible: "never",
			        icon: "gi-arrow-down gi-rot180",
			        run: (ev, ctx) => {
			            this.nextAndPreviousAction(false);
			        }
			    },
                actRefresh: {
                        icon: "gi-refresh",
                        name: "actRefresh",
                        caption: "jres:32131040",			//RC 32131040 : Ob�erstven�
                        run: () => {
                        this.refreshDetail();
                        }
                },
			});

			this.menuBar([
			    { action: this.actions.actRefresh, favorite: true, visible: !this.editMode },
			    { action: this.actions.actPrevious, favorite: true, align: "opposite", visible: !this.newRecord },
			    { action: this.actions.actNext, favorite: true, align: "opposite", visible: !this.newRecord },
			])
			this.actions.actPrevious?.enabled(this.gridRemoteControl.current()?.prevRow != null);
			this.actions.actNext?.enabled(this.gridRemoteControl.current()?.nextRow != null);

        }


		/** vytvo�it commandbar */
		private createCommandBar() {

			const commandBar: MenuParams[] = [];

            // CLOSE
			commandBar.push({								
				favorite: true,
				action: this.actions.add(new GAction({
					name: "actZavrit",
					icon: "gi-window-close",
					caption: "jres:32131042",				//RC 32131042 : Zav��t
					run: () => {
						this.close();
					}
				}))
			});

			this.commandBar(commandBar);
		}

		//#endregion
		//#region sidebar

		/** vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {

			this.panelId = "panelNahled";

			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
				leaf: "jres:32131038",								//RC 32131038 : N�hled
				icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel(ITypePanel.Neurceno, $(ev.target))
				},
			} as GSideBarPanelOptions;

			return panel;
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/** vytvo�it sidebar */
		private createSidebar() {

			this.removeSidebar();
			var myPanels: GSideBarBarOptions[] = [];

			var auditPristupu = new Gordic.Adm.WebControls.AdmAuditPristupu();
			var panelAudit = auditPristupu.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			myPanels.push(panelAudit);

			//var extIdentifikace = new Gordic.Adm.WebControls.AdmExtIdentifikace();
			//var panelExtIdentifikace = extIdentifikace.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelExtIdentifikace);

			//var poznamky = new Gordic.Adm.WebControls.AdmPoznamky();
			//var panelPoznamky = poznamky.create(this,  this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelPoznamky);

			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: myPanels
				}
			});
		}

		/** ob�erstven� panelu v sidebaru */
		private refreshPanel(type: ITypePanel, elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}

			if (panel !== undefined) {

				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}

				this.panelElement = $("<div>").appendTo(panel);

				//if (type === ITypePanel.HistorieSpusteni) {
				//	GridUtils.setPanelGrid("jres:32000055", this.row_historie_spusteni, this.gridFormatHistorieSpusteni, this.panelElement);
				//}
				//else {
					this.setPreviewEmpty();
				//}

			}

		}
        /** vytov�en� pr�zdn�ho sidebar panelu s n�hledek */
		private setPreviewEmpty(): void {
			var p7s_element = $("<div'>").addClass("Adm-p7s-class");
			p7s_element.appendTo(this.panelElement);
			p7s_element.text("jres:32131043"); //RC 32131043 : N�hled nen� k dispozici.
		}

		//#endregion


	}
}
